import { motion } from "motion/react";
import type { ReactNode } from "react";
import { useReducedMotion } from "../../hooks/useReducedMotion";

interface RevealProps {
  children: ReactNode;
  delay?: number;
  distance?: number;
  className?: string;
}

export function Reveal({
  children,
  delay = 0,
  distance = 24,
  className = "",
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  return (
    <motion.div
      className={`motion-element ${className}`}
      initial={reduceMotion ? false : { opacity: 0, y: distance }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.18 }}
      transition={{ duration: 0.72, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
